<template>
  <div class="employee-viewer">
    <AppMapPointPanelHeader :header="header" @close="$emit('close')" />
    <div class="employee-viewer__content">
      <AppMapPointPanelFirstRow
        @edit="edit"
        :title="employee.name"
        :id="employee.id"
        :img="avatarSrc"
        :avatar-size="avatarSize"
        :has-edit="can(PN.EMPLOYEE_UPDATE)"
        :has-preview="hasPreview"
      />
      <table class="table user-view-table m-0">
        <tbody>
          <tr v-if="desk.number">
            <td>Desk Number:</td>
            <td>{{ desk.number }}</td>
          </tr>
          <tr v-if="employee.email">
            <td>Email:</td>
            <td>
              <a :href="`mailto:${employee.email}`">{{ employee.email }}</a>
            </td>
          </tr>
          <tr v-if="displayEmpty || employee.phone">
            <td>Phone:</td>
            <td>{{ employee.phone }}</td>
          </tr>
          <tr v-if="displayEmpty || employee.cell">
            <td>Cell phone:</td>
            <td>{{ employee.cell }}</td>
          </tr>
          <tr v-if="displayEmpty || employee.department_id">
            <td>Department:</td>
            <td>{{ department.name }}</td>
          </tr>
          <tr v-if="displayEmpty || employee.position_id">
            <td>Position:</td>
            <td>{{ position.name }}</td>
          </tr>
          <tr v-if="displayEmpty || employee.hrid">
            <td>Employee ID:</td>
            <td>{{ employee.hrid }}</td>
          </tr>
          <tr v-if="displayEmpty || employee.note">
            <td>Note:</td>
            <td class="multiline">{{ employee.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as PN from '@/utils/PermissionNames'
import { getAvatarSrc } from '@/utils/Helpers'
import { getItemHeader } from '@/components/shared/helpers'
import AppMapPointPanelHeader from '@/components/shared/AppMapPointPanelHeader.vue'
import AppMapPointPanelFirstRow from '@/components/shared/AppMapPointPanelFirstRow.vue'
import { getIconUrl } from '@/components/leaflet/Icon'

export default {
  name: 'EmployeeViewer',
  components: { AppMapPointPanelFirstRow, AppMapPointPanelHeader },
  data: () => ({ PN }),
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    point: {
      type: Object
    },
    displayEmpty: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('employee', ['getEmployee']),
    ...mapGetters('department', ['getDepartment']),
    ...mapGetters('position', ['getPosition']),
    ...mapGetters('rbac', ['can']),
    ...mapGetters('desk', ['getDesk']),
    desk() {
      return this.getDesk(this.point.desk) || {}
    },
    header() {
      return getItemHeader(this.point, 'Employee')
    },
    employee() {
      return this.getEmployee(this.id) || {}
    },
    position() {
      return this.getPosition(this.employee.position_id) || {}
    },
    department() {
      return this.getDepartment(this.employee.department_id) || {}
    },
    iconSrc() {
      return getIconUrl(this.point.icon_id, this.point.file_updated_at)
    },
    avatarSize() {
      return this.employee.avatar_id ? '100px' : '50px'
    },
    hasPreview() {
      return this.employee.avatar_id
    },
    avatarSrc() {
      return getAvatarSrc(this.employee.avatar_id, this.employee.avatar_updated_at, this.iconSrc)
    }
  },
  methods: {
    edit() {
      this.$emit('edit')
    }
  }
}
</script>

<style>
.employee-viewer__content {
  padding: 24px;
}
</style>
